import axios from 'axios'

export default {
    getAll: () => axios.get(`/review`),
    getById: id => axios.get(`/review/${id}`),
    create: formData => axios.post(`/review/create`, formData),
    edit: formData => axios.put(`/review/edit`, formData),
    delete: id => axios.delete(`/review/delete/${id}`),
    changeStatus: formData => axios.patch(`/review/toggle_status`, formData)
}